import { localStorage, sessionStorage } from '../libs/storage'

export const setAuth = (state, auth) => {
  state.auth = auth
  localStorage.set('auth', auth)
}

export const logout = (state) => {
  setAuth(state, null)
  setInitialInfo(state, {})
  sessionStorage.clear()
}

export const setCallState = (state, code) => {
  state.callState = code
}

export const setCallInfo = (state, info) => {
  state.callInfo = info || {}
}

export const setInitialInfo = (state, initialInfo) => {
  state.initialInfo = initialInfo || {}
}

export const setWant2call = (state, info) => {
  state.want2call = info
}
export const setCallReason = (state, info) => {
  state.callReason = info
}

//-----------------
export const SET_ONEOLDER = (state, obj) => {
  state.oneOlder = obj
}
export const setSearchForm = (state, obj) => {
  state.currentSearchForm = obj
}